import IEntity from "./Entity";
import IUser from "./User";

export default interface INFSe extends IEntity {
	mei?: any;
	company?: any;
	service?: string;
	serviceType?: string;
	nbsCode?: string;
	value?: string | any;
	pdf?: string;
	xml?: string;
	dataKey?: string;
	code?: string;
	nfseId?: string;
	status?: NFSeStatus | any;
	statusReason?: string;
	filename?: string;
	createdBy?: IUser | any;
	// Municipality fields for service location
	municipalityCode?: string;
	municipalityDescription?: string;
	// Complementary municipal code for ISSQN incidence
	complementaryMunicipalCode?: string;
	/** Optional URL for NFse webhook notifications (processing, generated, error, canceled). */
	nfseWebhookUrl?: string;
}

export enum NFSeStatus {
	Requested = -1,
	Pending = 0,
	Generated = 1,
	Canceled = 2,
	Processing = 3,
	Error = 9
}
